import { keyframes } from "@emotion/react";

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`;

export const div = {
  position: "relative",
  margin: "0 auto",
  width: "50px",

  "::before": {
    content: "''",
    display: "block",
    pt: "100%",
  },

  svg: {
    animation: `${rotate} 2s linear infinite`,
    height: "100%",
    transformOrigin: "center center",
    width: "100%",
    position: "absolute",
    top: "0",
    bottom: "0",
    left: "0",
    right: "0",
    margin: "auto",

    circle: {
      stroke: (theme) => theme.colors.primary,
      strokeDasharray: "1, 200",
      strokeDashoffset: "0",
      animation: `${dash} 1.5s ease-in-out infinite`,
      strokeLinecap: "round",
    },
  },
};
